<template>
    <base-modal
        classes="modal-sm"
        @close="$emit('close')"
    >
        <div
            slot="header"
            class="h5"
        >
            Sélection du type
        </div>

        <div slot="body">
            <div class="row">
                <div class="col-12">
                    <base-select
                        v-model="params.type"
                        :options="optionsTypeDossier"
                    >
                        Type de dossier
                    </base-select>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button
                :disabled="!params.type"
                class="btn btn-success mr-2"
                @click="$emit('next-step', params)"
            >
                Suivant
            </button>

            <button
                class="btn btn-danger"
                @click="$emit('close')"
            >
                Annuler
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseSelect from '../templates/BaseSelect'
    import {mapGetters} from "vuex"

    export default {
        name: "SelectionTypeDossierModal",

        components: {BaseModal, BaseSelect},

        props: {
            filters: {
                type: Object, default: () => {
                }
            },
        },

        data: function () {
            return {
                params: {
                    ...this.dossier,
                    type: null,
                },
            }
        },

        computed: {
            ...mapGetters(['optionsTypeDossier']),
        },
    }
</script>
